export const DndRegistrationActionType = {
    FETCH_DND_MAPPING_AND_PREFERENCES_LOADING: 'FETCH_DND_MAPPING_AND_PREFERENCES_LOADING',
    FETCH_DND_MAPPING_AND_PREFERENCES_SUCCESS: 'FETCH_DND_MAPPING_AND_PREFERENCES_SUCCESS',
    FETCH_DND_MAPPING_AND_PREFERENCES_ERROR: 'FETCH_DND_MAPPING_AND_PREFERENCES_ERROR',
    FETCH_DND_MAPPING_LOADING: 'FETCH_DND_MAPPING_LOADING',
    FETCH_DND_MAPPING_SUCCESS: 'FETCH_DND_MAPPING_SUCCESS',
    FETCH_DND_MAPPING_ERROR: 'FETCH_DND_MAPPING_ERROR',
    DND_REGISTRATION_MOBILE_LOADING: 'DND_REGISTRATION_MOBILE_LOADING',
    DND_REGISTRATION_MOBILE_SUCCESS: 'DND_REGISTRATION_MOBILE_SUCCESS',
    DND_REGISTRATION_MOBILE_ERROR: 'DND_REGISTRATION_MOBILE_ERROR',

    SET_DND_PREFERENCES: 'SET_DND_PREFERENCES',
    SET_CATEGORY_WISE_PREFERENCE_LIST: 'SET_CATEGORY_WISE_PREFERENCE_LIST',
    SET_DND_MAPPING: 'SET_DND_MAPPING',
    SET_PREFERENCE_LIST: 'SET_PREFERENCE_LIST',
    SET_SELECTED_PREFERENCE_LIST: 'SET_SELECTED_PREFERENCE_LIST',
    TOGGLE_ADVANCE: 'TOGGLE_ADVANCE',
    CLOSE_ADVANCE: 'CLOSE_ADVANCE',
    ENABLE_MORE_PREFERENCES: 'ENABLE_MORE_PREFERENCES'
}